import { http } from '@/core/api/';
import {
  isTapRelatedFilter,
  isTapSupplementaryFilter,
  modelToPayload,
  payloadToModel,
} from './_utils';
import { servicesEnum } from './_types';

//
//* Catalog
//! Important: properties order must remain the same.
//

export const catalogApi = {
  services: async (type) => {
    try {
      const { data } = await http.get(
        '/api/code/disciplines/validForTapRequests'
      );

      if (type === 'related') {
        return data?.filter(isTapRelatedFilter) || [];
      }

      if (type === 'supplementary') {
        return data?.filter(isTapSupplementaryFilter) || [];
      }

      return data || [];
    } catch {
      return [];
    }
  },

  modalities: async (type, { serviceId } = {}) => {
    let payload = null;

    switch (type) {
      case 'related':
        payload = { forTh: true };
        break;

      case 'supplementary':
        switch (serviceId) {
          case servicesEnum.Educativo:
            payload = { forEdu: true };
            break;

          case servicesEnum['Servicio para Ciegos']:
          case servicesEnum['Servicio para Sordos']:
          case servicesEnum['Educación Física Adaptada']:
          case servicesEnum['Educación Física Adaptada/Combinada']:
            payload = { forPei: true, forEFA: true };
            break;
        }
        break;
    }

    try {
      const { data } = await http.get('/api/code/servicemodalities', {
        params: payload,
      });
      return data;
    } catch {
      return [];
    }
  },

  frequencies: async () => {
    try {
      const { data } = await http.get('/api/code/frequencytype');
      return data;
    } catch {
      return [];
    }
  },

  durations: async (type, { serviceId } = {}) => {
    let payload = null;

    switch (type) {
      case 'related':
        payload = { forRemedy: true, forPei: true, forEdu: true };
        break;

      case 'supplementary':
        switch (serviceId) {
          case servicesEnum.Educativo:
            payload = { forEdu: true };
            break;

          case servicesEnum['Servicio para Ciegos']:
          case servicesEnum['Servicio para Sordos']:
          case servicesEnum['Educación Física Adaptada']:
          case servicesEnum['Educación Física Adaptada/Combinada']:
            payload = { forRemedy: true, forPei: true, forEdu: true };
            break;
        }
        break;
    }

    try {
      const { data } = await http.get('/api/code/therapydurations', {
        params: payload,
      });
      return data;
    } catch {
      return [];
    }
  },

  approaches: async ({ serviceId, modalityId }) => {
    try {
      const { data } = await http.get(
        `api/pei/getcodeapproachtypes?disciplineTypeCd=${serviceId}&serviceModalityId=${modalityId}`
      );
      return data;
    } catch {
      return [];
    }
  },

  teachers: async () => {
    try {
      const { data } = await http.get('/api/pei/getteachertypes');
      return data;
    } catch {
      return [];
    }
  },

  places: async () => [
    { id: 137, name: 'CSEE' },
    { id: 482, name: 'Hogar' },
    { id: 135, name: 'Escuela' },
    { id: 136, name: 'Oficina del Proveedor' },
  ],
};

//
//* Services Provided
//

export const servicesProvidedApi = {
  getAll: async (tapRequestId) => {
    try {
      const { data } = await http.get(
        `api/tapRequests/${tapRequestId}/services`
      );
      if (data) {
        return [...data].map(payloadToModel);
      }
      return [];
    } catch {
      return [];
    }
  },

  create: async (tapRequestId, model) => {
    try {
      const payload = modelToPayload(tapRequestId, model);
      const { data } = await http.post(
        `api/tapRequests/${tapRequestId}/services`,
        payload
      );
      return data ? payloadToModel(data) : null;
    } catch {
      return null;
    }
  },

  edit: async (tapRequestId, id, model) => {
    try {
      const payload = modelToPayload(tapRequestId, model);
      const { data } = await http.put(
        `api/tapRequests/${tapRequestId}/services/${id}`,
        payload
      );
      return data ? payloadToModel(data) : null;
    } catch {
      return null;
    }
  },

  remove: async (tapRequestId, id) => {
    try {
      await http.delete(`api/tapRequests/${tapRequestId}/services/${id}`);
      return true;
    } catch {
      return null;
    }
  },
  getTapRequestStatus: async (tapRequestId) => {
    const { data } = await http.get(
      `api/tapRequests/status?tapRequestId=${tapRequestId}`
    );

    return data;
  },
};

export const getTherapyservicesfilters = async () => {
  const { data } = await http.get(`api/tapRequests/therapyservicesfilters`);

  return data;
};
